



















import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
@Component
export default class HelloWorld extends myVue {
    handleCommand(command:any) {
        command.item.click()
    }
    get breadcrumbList(){
        return this.current.breadcrumbList;
    }
}
